let css = require('./field-mapping.css');
const { Select, Text } = require('../../../../../../packages/account-ui');
const signals = require('../../../../../../signals/bitrix');
const utils = require('../../../../../../signals/utils');
const { cut } = require('../../../../../../helpers/utils');
const SCHEMES = require('../../../../../../helpers/scheme');

class FieldMapping {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            return Object.assign({}, data, { css });
        });
    }

    bind () {
        this.$context.signal(signals.validateMapping);
        return {
            click: {
                [cut(css.toggleNew)]: this.toggleNew
            }
        };
    }

    toggleNew (e) {
        e.stopPropagation();
        let id = e.currentTarget.getAttribute('cat-id');
        let path = ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', id, 'isNew'];
        this.$context.signal(signals.toogleFieldMappingIsNew, { path });
    }
}

module.exports = {
    constructor: FieldMapping,
    children: [
        {
            name: 'select',
            component: Select,
            props: {
                signalOnSelect: signals.selectHermesToBitrixLeadMapping,
                signalOnToggle: utils.togglePopupFromArgs
            },
            watcher: (attributes) => ({
                options: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'bitrixFields'],
                isDisable: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping',
                    attributes['cat-field'], 'isDisable'],
                isOpen: ['account', 'popups', 'bitrixExportLeads', 'mapping', attributes['cat-field'], 'isOpen'],
                isError: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'isError'],
                header: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'header']
            })
        },
        {
            name: 'new-field',
            component: Text,
            props: {
                signals: { inputText: signals.inputTextWithValidateMapping,
                    blurText: signals.blurTextWithValidateMapping },
                placeholder: 'Введите название нового поля...',
                scheme: SCHEMES.stringOnlyLettersAndDigitsNotEmpty,
                hideTooltip: true
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'newLabel'],
                error: ['account', 'orders', 'currentOrder', 'bitrixExportLeads', 'mapping', attributes['cat-field'],
                    'error']
            })
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/bitrix-export-leads/field-mapping/index.js